import { render, staticRenderFns } from "./EzLoader.vue?vue&type=template&id=1354245a&scoped=true&"
import script from "./EzLoader.vue?vue&type=script&lang=js&"
export * from "./EzLoader.vue?vue&type=script&lang=js&"
import style0 from "./EzLoader.vue?vue&type=style&index=0&id=1354245a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1354245a",
  null
  
)

export default component.exports